import React, { useState } from 'react'
import { Outlet, useLocation } from 'react-router-dom'

import Nav from './nav'
import Header from './header/Header'
import { Box } from '@mui/material'
import SetupWatcher from './SetupWatcher'
import { blue } from '@mui/material/colors'
import useIsMobile from './hooks/useIsMobile'

function App() {
  const [navOpen, setNavOpen] = useState(true)
  const { pathname, search } = useLocation()

  const isInDashboard = pathname.includes('/dashboard')
  const hiddenLeftNav =
    pathname.includes('setup') ||
    (pathname.includes('/billing') && search.includes('unpaid=true'))

  const isMobile = useIsMobile()

  return (
    <>
      {!hiddenLeftNav && <SetupWatcher navOpen={navOpen} />}
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          height: `calc(100vh - ${isMobile ? 66 : 0}px)`,
          transition: 'all 195ms cubic-bezier(0.4, 0, 0.6, 1) 0ms',
          pl: isMobile || hiddenLeftNav ? null : navOpen ? '246px' : 12,
          pb: isMobile ? '66px' : null,
          background: '#e3f2fd',
        }}
      >
        <Nav open={navOpen} setOpen={setNavOpen}></Nav>

        <Header navOpen={navOpen} setNavOpen={setNavOpen} />
        <Box
          id='scroll-container'
          sx={{
            flexGrow: 1,
            py: 2,
            px: 3,
            mt: isInDashboard ? '144px' : '112px',
            overflow: 'scroll',
            backgroundColor: blue[50],
          }}
        >
          <Outlet />
        </Box>
      </Box>
    </>
  )
}

export default App
